module.exports = __webpack_public_path__ + "b8f6d25a93612297bc2916a38354aa20.png";